import { SwedishLanguageCode } from 'frontend/enums'
import { FilterProp, PanelOption } from 'frontend/types'
import { filterLanguageClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import { activeOptionLabel } from 'frontend/utils/helpers'
import Panel from './Panel/Panel'
import { SearchParams } from 'backend/services/types/urApiService.types'

const TOP_OPTIONS = [
  SwedishLanguageCode.SWEDISH.valueOf(),
  SwedishLanguageCode.EASY_SWEDISH.valueOf(),
  SwedishLanguageCode.SWEDISH_SIGN.valueOf(),
]

export const getTopOptions = (languages: FilterProp[]): PanelOption[] =>
  languages.reduce(
    (topOptions: FilterProp[], lang) =>
      TOP_OPTIONS.includes(lang.value) ? [...topOptions, lang] : topOptions,

    [],
  )

type LanguageProps = {
  handlePanelClick: () => void
  isOpen: boolean
  languages: FilterProp[]
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
}

const Language = ({
  handlePanelClick,
  isOpen,
  languages,
  searchParams,
  updateSearch,
}: LanguageProps) => {
  const language = searchParams.language || ''

  const topOptions = getTopOptions(languages)

  const sortedLanguageOptions = languages
    .map(lang => {
      return {
        available: lang.available,
        label: lang.label,
        value: lang.label,
      }
    })
    .sort((a, b) => a.label.localeCompare(b.label, 'sv'))

  const options = topOptions.concat(sortedLanguageOptions)

  const activeLabels = activeOptionLabel(options, language, true)

  const handleOptionSelect = (option: PanelOption) => {
    const isSelected = activeLabels.includes(option.label)

    if (!isSelected) filterLanguageClick(option.label)

    updateSearch({ language: option.label })
  }

  return (
    <Panel
      activeLabels={activeLabels}
      ariaLabel="Filtrera på språk"
      dataTrk="filter-language"
      handlePanelClick={handlePanelClick}
      isOpen={isOpen}
      label="Språk"
      onOptionSelect={handleOptionSelect}
      options={options}
    />
  )
}

export default Language
